import { Grid, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Toolbar } from '@roc/ui';
import { observer } from 'mobx-react';
import { useRef } from 'react';
import { useBalanceSheetReportStore } from "../../hooks/useBalanceSheetReportStore";
import { balanceSheetReportTabLabels } from '../../utils/constants';

const useStyles = makeStyles(theme => ({
  buttonContainer: {
    display: 'flex',
    gap: '10px'
  },
  selectorFilterContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  selectorFilter: {
    width: '180px',
    marginRight: '16px',
  },
  containerBox: {
    display: 'flex',
  },
  infoItemsBox: {
    marginRight: '40px',
    marginLeft: '25px',
    display: 'flex',
    alignItems: 'center',
    gap: '30px'
  },
}));

export const BalanceSheetReportToolbar = observer(() => {
  const classes = useStyles();
  const { balanceSheetReportStore } = useBalanceSheetReportStore();
  const { tab } = balanceSheetReportStore;
  const anchorRef = useRef(null);

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Toolbar>
            <Box className={classes.containerBox}>
              <Box style={{ textAlign: 'center' }}>
                <div ref={anchorRef} style={{ display: 'inline-flex', gap: '10px' }}>
                  <Button
                    onClick={() => balanceSheetReportStore.exportReport()}
                    testId="open_menu"
                    variant="contained"
                    size="small"
                    color="primary"
                  >
                    Export Balance Sheet Report
                  </Button>
                  <Button
                    onClick={() => balanceSheetReportStore.exportLoans()}
                    testId="open_menu"
                    variant="contained"
                    size="small"
                    color="primary"
                  >
                    Export {balanceSheetReportTabLabels[tab]} Report
                  </Button>
                </div>
              </Box>
            </Box>
          </Toolbar>
        </Grid>
      </Grid>
    </>
  );
});